import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<
  Pick<ChallengeFormType, 'thumbnailImageUrl'>
> = ({ thumbnailImageUrl }) => {
  if (!thumbnailImageUrl)
    return { isValid: false, message: '썸네일 이미지를 등록해주세요.' };
  return { isValid: true, message: '' };
};
